import { render } from "./SessionPage.vue?vue&type=template&id=0676dc38&scoped=true"
import script from "./SessionPage.vue?vue&type=script&lang=js"
export * from "./SessionPage.vue?vue&type=script&lang=js"

import "./SessionPage.vue?vue&type=style&index=0&id=0676dc38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0676dc38"]])

export default __exports__